import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { GuestTaskApi } from '@/domains/guest/apis/guest-task-api';
import { GuestTaskApiImpl } from '@/domains/guest/apis/impls/guest-task-api-impl';
import { GuestTaskMigrationService } from '@/domains/guest/services/guest-task-migration-service';
import { GuestTaskMigrationServiceImpl } from '@/domains/guest/services/impls/guest-task-migration-service-impl';

/**
 * 游客任务迁移模块
 * 负责注册游客任务相关的服务和 API
 */
export const guestModule = new ContainerModule((bind) => {
    bind(GuestTaskApi).to(GuestTaskApiImpl);
    bind(GuestTaskMigrationService).to(GuestTaskMigrationServiceImpl);
});
